export const GET_CLIENT_DIAGNOSES = 'GET_CLIENT_DIAGNOSES';
export const GET_CLIENT_DIAGNOSES_SUCCESS = 'GET_CLIENT_DIAGNOSES_SUCCESS';

export const CREATE_CLIENT_DIAGNOSIS = 'CREATE_CLIENT_DIAGNOSIS';
export const EDIT_CLIENT_DIAGNOSIS = 'EDIT_CLIENT_DIAGNOSIS';
export const SET_PRIMARY_CLIENT_DIAGNOSIS = 'SET_PRIMARY_CLIENT_DIAGNOSIS';
export const DELETE_CLIENT_DIAGNOSIS = 'DELETE_CLIENT_DIAGNOSIS';

export const GET_DIAGNOSIS_MATCH = 'GET_DIAGNOSIS_MATCH';
export const GET_DIAGNOSIS_MATCH_SUCCESS = 'GET_DIAGNOSIS_MATCH_SUCCESS';
export const CLEAR_DIAGNOSIS_MATCH = 'CLEAR_DIAGNOSIS_MATCH';
